import style from './style';
import compose from './compose';
export var color = style({
  prop: 'color',
  themeKey: 'palette'
});
export var bgcolor = style({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette'
});
var palette = compose(color, bgcolor);
export default palette;


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/system/esm/palette.js
// module id = 858
// module chunks = 121